import { kStandardMargins, kDenseMargins, kManualMargins } from "../constants";

export function MarginModeValid(theMode) {
  switch (theMode) {
    case kStandardMargins:
    case kDenseMargins:
    case kManualMargins:
      return true;
      break;
  }

  return false;
}
